<template>
  <div class="s_bf2" :style="'padding:'+(data.style.paddingTB*0.9)+'px '+(data.style.paddingLR*0.9) +'px'">
      <div class="diy-notice dis-flex" :style="'background-color:'+data.style.backgroundColor" >
        <div class="notice__icon"><SoundFilled :style="'font-size:16px;color:'+data.style.iconColor" /></div>
        <div class="notice__text flex-box am-text-truncate"><span :style="'color:'+data.style.textColor">{{data.params.content}}</span></div>
      </div>
  </div>
</template>
<script>
  import { SoundFilled} from "@ant-design/icons-vue";
export default {
    components: { SoundFilled},
  props: { data: Object },
  name: "notice",
};
</script>
<style lang="less" scoped>
.diy-notice {
  display: flex;
  align-items: center;
  border-radius: 25px;
  overflow: hidden;
  .notice__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px 10px;
    img {
      width: 16px;
      height: 12px;
    }
  }
  .notice__text{
    padding-left: 5px;
    font-size: 12px;
    flex:1;
    height: 15px;
    line-height: 15px;
    display: flex;
    position: relative;
    overflow: hidden;
    span{
      position: absolute;
      white-space: nowrap;
      transition-timing-function:linear;
      animation: loop 10.48s linear infinite ;
    }
  }
}
@keyframes loop{
   0%{
     transform: translateX(300px);
   }
   100%{
     transform: translateX(-196px);
   }
}
</style>